module.exports = __webpack_public_path__ + "img/img20.5028b2b0.svg";